import { render, staticRenderFns } from "./ProductsPageContainer.vue?vue&type=template&id=9f8343ba&scoped=true"
import script from "./ProductsPageContainer.vue?vue&type=script&lang=ts"
export * from "./ProductsPageContainer.vue?vue&type=script&lang=ts"
import style0 from "./ProductsPageContainer.vue?vue&type=style&index=0&id=9f8343ba&prod&lang=scss&scoped=true"
import style1 from "./ProductsPageContainer.vue?vue&type=style&index=1&id=9f8343ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8343ba",
  null
  
)

export default component.exports